import { useState, useEffect } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Images
import bgImage from "assets/images/icons/catering-icons/food_3.svg";

import { verifyCustomerOtp, verifyTokenApi, resendOtp } from "../_request";
import { getAuthLocal } from "../../../core/AuthHelper";
import EmailVerification from "../components/EmailVerification";
import { useAuth } from "context";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import SideBanner from "../../../examples/LayoutContainers/SideBanner";
import Divider from "@mui/material/Divider";
import { useLocation } from "react-router-dom";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { getCustomerAPI } from "../../profile/_request";
import { updateCustomerInfoForCampaign } from "../_request";
import { getCampaignDetails } from "layouts/dashboard/_request";

const VerifyCustomer = () => {
  const { showSnackbarWithMessage, saveAuthData, auth } = useAuth();
  const navigate = useNavigate();
  const forgotPassword = useLocation().pathname === "/authentication/forgot-password";
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [campaignCode, setCampaignCode] = useState(null);
  const [campaignExist, setcampaignExist] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [isCampaignAvailable, setIsCampaignAvailable] = useState(false);
  const [campaign, setCampaign] = useState("");
  const [restaurantName, setRestauranttName] = useState("");

  const [emails, setEmails] = useState([
    {
      email: "",
      isOTPVisible: true,
      otpNumber: "",
      emailError: "",
      optError: "",
      disabled: false,
      isVerified: false,
    },
  ]);

  useEffect(() => {
    const verifyTokenFunc = async () => {
      try {
        const auth = await getAuthLocal();
        const {
          data: { success, data },
        } = await verifyTokenApi({ accessToken: auth.accessToken });
        if (success) {
          const updatedEmails = [...emails];
          updatedEmails[0].email = data.verifiedData.email;
          updatedEmails[0].disabled = true;
          setEmails(updatedEmails);
        }
      } catch (e) {
        console.log(e.message);
      }
    };
    if (auth) verifyTokenFunc();
  }, []);

  useEffect(() => {
    const getCustomerDetails = async () => {
      const {
        data: { success, data },
      } = await getCustomerAPI();
      if (success) {
        let customerAccounts;
        if (data.customer.verifiedAt) {
          customerAccounts = {
            email: data.customer.email,
            isOTPVisible: data.customer?.verifiedAt !== null,
            otpNumber: "",
            isVerified: data.customer?.verifiedAt !== null,
            isAuthFlow: true,
          };
          setEmails([customerAccounts]);
        } else {
          customerAccounts = {
            email: "",
            isOTPVisible: false,
            otpNumber: "",
            disabled: false,
            isVerified: false,
            isAuthFlow: true,
          };
        }
        setEmails([customerAccounts]);
        if (data.customer?.customer_restaurant_stores_infos.length > 0) {
          setcampaignExist(
            data.customer?.customer_restaurant_stores_infos[0]
              ?.customer_restaurant_stores_info_campaigns[0].campaign.code
          );
        }
      }
    };
    if (auth) getCustomerDetails();
  }, []);

  const handleFieldChange = (event, index) => {
    const { name, value } = event.target;
    const updatedEmails = [...emails];
    updatedEmails[index][name] = value;
    setEmails(updatedEmails);
  };

  const handleVerify = async (index) => {
    try {
      const {
        data: { success, message, data },
      } = await verifyCustomerOtp({ code: +emails[index].otpNumber });
      if (success) {
        saveAuthData(data.tokens);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };
  const handleVerifyForgotPassword = async (index) => {
    try {
      const {
        data: { success, message, data },
      } = await verifyCustomerOtp({
        code: +emails[index].otpNumber,
        forgotPassword: true,
        userEmail: emails[index].email,
      });
      if (success) {
        saveAuthData(data.tokens);
        navigate("/dashboard", { state: { forgotPassword: data.forgotPassword } });
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  const handleReSendOTP = async (index) => {
    try {
      setIsSendingOTP(true);
      const {
        data: { success, message, data },
      } = await resendOtp(
        forgotPassword ? true : false,
        encodeURIComponent(emails[index]?.email?.trim())
      );
      if (success) {
        const updatedEmails = [...emails];
        updatedEmails[index].isOTPVisible = true;
        setEmails(updatedEmails);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
        setIsSendingOTP(false);
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
        setIsSendingOTP(false);
      }
    } catch (e) {
      console.log(e.message);
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
      setIsSendingOTP(false);
    }
  };
  const createInfoData = async () => {
    try {
      const {
        data: { success, message },
      } = await updateCustomerInfoForCampaign(campaignCode);
      if (success) {
        setcampaignExist(campaignCode);
        setIsVerified(true);
        showSnackbarWithMessage({
          type: "success",
          message,
        });
      } else {
        showSnackbarWithMessage({
          type: "error",
          message,
        });
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    }
  };

  const campaignData = async () => {
    try {
      const {
        data: { success, data },
      } = await getCampaignDetails();
      if (success) {
        setIsCampaignAvailable(data?.isCampaign);
        setCampaign(data?.campaign);
        setRestauranttName(data?.restaurantName);
      } else {
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    !forgotPassword && campaignData();
  }, [isVerified]);
  return (
    <MDBox
      display={{
        xs: "flex",
        xl: "row",
        background: "linear-gradient(to right, rgba(1,233,98,0.1), rgba(0,123,255,0.1))",
      }}
      flexDirection={{
        xs: "column-reverse",
        xl: "row",
      }}
    >
      <SideBanner />
      <BasicLayout image={bgImage}>
        <Card sx={{ margin: 2, marginLeft: 3, maxWidth: "648px" }}>
          <MDBox mx={1} mt={2} p={2} minWidth={{ xs: "320px", xl: "380px" }}>
            <MDTypography variant="h4" fontWeight="regular">
              {!forgotPassword ? "Email Verification" : "Forgot Password"}
            </MDTypography>
          </MDBox>
          <MDBox pt={3} pb={3} px={2}>
            <MDBox>
              {emails.map((emailData, index) => (
                <>
                  <EmailVerification
                    key={index}
                    emailData={emailData}
                    index={index}
                    onFieldChange={handleFieldChange}
                    onVerify={forgotPassword ? handleVerifyForgotPassword : handleVerify}
                    onSendOTP={handleReSendOTP}
                    isSendingOTP={isSendingOTP}
                    isForgotPassword={true}
                  />
                  <Divider />
                </>
              ))}
            </MDBox>
            {emails[0]?.isVerified && (
              <>
                <MDTypography variant="h6" fontWeight="regular" pb={1}>
                  Do you have any promotion code?&nbsp;(optional)
                </MDTypography>
                <MDInput
                  type="text"
                  label={!campaignExist && "Campaign Code"}
                  name="campaignCode"
                  variant="outlined"
                  disabled={campaignExist}
                  value={campaignExist ? campaignExist : campaignCode}
                  onChange={(e) => setCampaignCode(e.target.value)}
                />
                {campaignExist ? (
                  <>
                    <MDButton
                      variant="text"
                      color="success"
                      sx={{ cursor: "default", pointerEvents: "none" }}
                    >
                      Applied
                    </MDButton>
                  </>
                ) : !campaignExist && campaignCode ? (
                  <MDButton
                    variant="text"
                    color="info"
                    onClick={() => {
                      createInfoData();
                      campaignData();
                    }}
                  >
                    Verify
                  </MDButton>
                ) : null}
              </>
            )}

            {isCampaignAvailable && campaignExist && (
              <MDBox
                variant="text"
                p={1}
                mt={3}
                sx={{
                  backgroundColor: "#d4edda",
                  display: "inline-flex",
                  borderRadius: "4px",
                }}
                size="large"
              >
                {campaign?.type === "FIXED" ? (
                  <MDTypography variant="button" fontWeight="normal" sx={{ cursor: "initial" }}>
                    You are enrolled in
                    <span style={{ fontWeight: "bold" }}>{` ${campaign?.name}`}</span> campaign
                    of&nbsp;
                    <span style={{ fontWeight: "bold" }}>{`${restaurantName}`}</span>
                    &nbsp;restaurant. Enjoy additional reward of{" "}
                    <span
                      style={{ fontWeight: "bold" }}
                    >{`${campaign?.fixedCashback} points`}</span>{" "}
                    on your first order.
                    {campaign.minimumOrderValueInCents !== "0" && (
                      <>
                        {" "}
                        Order minimum value must be greater than
                        <span
                          style={{ fontWeight: "bold" }}
                          dangerouslySetInnerHTML={{
                            __html: ` $${campaign.minimumOrderValueInCents / 100}`,
                          }}
                        />
                        .
                      </>
                    )}
                    {campaign.campaignExpiry && (
                      <>
                        {" "}
                        This offer will expire on
                        <span
                          style={{ fontWeight: "bold" }}
                          dangerouslySetInnerHTML={{
                            __html: ` ${new Date(campaign.campaignExpiry).toDateString()}`,
                          }}
                        />
                        .
                      </>
                    )}
                  </MDTypography>
                ) : (
                  <MDTypography variant="button" fontWeight="normal" sx={{ cursor: "initial" }}>
                    You are enrolled in
                    <span style={{ fontWeight: "bold" }}>{` ${campaign?.name}`}</span> campaign
                    of&nbsp;
                    <span style={{ fontWeight: "bold" }}>{` ${restaurantName}`}</span>
                    &nbsp;restaurant. Benefit from an additional cashback of{" "}
                    <span style={{ fontWeight: "bold" }}>+{campaign.multiplierCashback}X</span> on
                    top of your existing cashback incentive. Get bonus rewards points with every
                    order{campaign.minimumOrderValueInCents === "0" && "."}
                    {campaign.minimumOrderValueInCents !== "0" && (
                      <>
                        {", "}
                        with a minimum order value greater than
                        <span
                          style={{ fontWeight: "bold" }}
                          dangerouslySetInnerHTML={{
                            __html: ` $${campaign.minimumOrderValueInCents / 100}`,
                          }}
                        />
                      </>
                    )}
                    {campaign.campaignExpiry && (
                      <>
                        . This offer will expire on
                        <span
                          style={{ fontWeight: "bold" }}
                          dangerouslySetInnerHTML={{
                            __html: ` ${new Date(campaign.campaignExpiry).toDateString()}`,
                          }}
                        />
                        .
                      </>
                    )}
                  </MDTypography>
                )}
              </MDBox>
            )}
            {((!campaignCode && emails[0]?.isVerified) || campaignExist) && (
              <MDBox mt={4} mb={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton
                  variant={
                    !campaignExist && !campaignCode && emails[0]?.isVerified
                      ? "outlined"
                      : "gradient"
                  }
                  color="success"
                  onClick={() => navigate("/dashboard")}
                >
                  Continue
                </MDButton>
              </MDBox>
            )}
          </MDBox>
        </Card>
      </BasicLayout>
    </MDBox>
  );
};

export default VerifyCustomer;
